<template>
  <div class="home">
    <Platforms></Platforms>
  </div>
</template>

<script>
import Platforms from '@/components/Platforms.vue'

export default {
  name: 'Home',
  components: {
    Platforms
  }
  // created() {
  //   this.aa();
  // },
  // mounted() {
  //   let aa = 1;
  //   aa.pring();
  // }
}
</script>
